import Vue from "vue";
import Axios from "./plugins/axios";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import loadFonts from "./plugins/webfontloader";
import router from "./router";
import store from "./store";
import Toast from "vue-toastification";
import toastOptions from "@/plugins/toast";
import "./plugins/datetime";
import VueCookies from "vue-cookies";
import custom from "@/plugins/custom";
import Dialogs from "@/mixins/dialog";
import Validation from "@/mixins/validation";
import Global from "@/mixins/global";
import httpHelpers from "@/mixins/httpHelpers";
import * as Sentry from "@sentry/vue";
import moment from "moment";
import humanizeDuration from "humanize-duration";
import PackageAccess from "@/components/global/PackageAccess.vue";
import DatePicker from "vue2-datepicker";
import dev from "./schema/dev.js";
import "./methodOverload"
/* these import help to prevent chunk file */
import "dompurify";
import "@/plugins/chart";
import "@/plugins/site-statistics";
import "@/config";

/* these import help to prevent chunk file */

loadFonts().then(() => {
});

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    Vue,
    dsn: "https://1137edf4735261535f823a8b9df13d62@o4505941271838720.ingest.sentry.io/4505946376699904",
    environment: "production",
    integrations: [
      Sentry.browserTracingIntegration({
        tracePropagationTargets: [
          "app.virtualautomationengineer.com/",
          "uk.virtualautomationengineer.com/",
          "app.functionize.com/",
          "www1.functionize.com/",
          "appuk.functionize.com/",
          "dev.functionize.com/",
        ],
        router,
        routeLabel: "path",
      }),
      Sentry.replayIntegration(),
    ],
    logErrors: true,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const bus = new Vue();

Vue.prototype.$duration = humanizeDuration.humanizer({
  language: "shortEn",
  languages: {
    shortEn: {
      y: (y) => (y > 1 ? "years" : "year"),
      mo: (m) => (m > 1 ? "months" : "month"),
      w: (w) => (w > 1 ? "weeks" : "week"),
      d: (d) => (d > 1 ? "days" : "day"),
      h: (h) => (h > 1 ? "hours" : "hour"),
      m: (m) => (m > 1 ? "mins" : "min"),
      s: (s) => (s > 1 ? "secs" : "sec"),
    },
  },
});

Vue.prototype.$moment = moment;
Vue.prototype.$http = Axios;
Vue.prototype.$event = bus;
Vue.use(Toast, toastOptions);
Vue.use(VueCookies, {});
Vue.use(custom);
Vue.component("PackageAccess", PackageAccess);
Vue.mixin({
  data: () => ({
    v_rule: Validation.v_rule,
    ...dev,
    statusColors: {
      N: 0xdc7283,
      Y: 0x0ca671,
      W: 0xf4b95f,
      I: 0x8e73d7,
    },
  }),
  computed: {
    ...Global.computed,
    readOnlyMode: {
      get() {
        return this.store.state.readOnlyMode;
      },
    },
    viewableMode: {
      get() {
        return this.store.state.viewableMode;
      },
    },
    viewType: {
      get() {
        return this.store.state.viewType;
      },
    },
  },
  components: { DatePicker },
  methods: {
    ...Dialogs.methods,
    ...Global.methods,
    ...httpHelpers.methods,
  },
});

store.dispatch("getWindowVar").then(() => {
  new Vue({
    App,
    vuetify,
    store,
    render: (f) => f(App),
    router,
  }).$mount("#app");
});

Vue.prototype.$readOnlyMode = store.state.readOnlyMode;
Vue.prototype.$viewableMode = store.state.viewableMode;
Vue.prototype.$viewType = store.state.viewType;

window.loadFreshData = true;
setTimeout(() => {
  window.loadFreshData = false;
}, 8000);
